import axios from 'axios'
import { CADASTRAR_AGENDAMENTO_VIAGEM_PASSAGEIRO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cadastrarAgendamentoViagemPassageiros (pasageiros) {
  const url = `${URL}/agendamento-viagem/cadastrar/passageiros`;
  return dispatch => axios.post(url, pasageiros, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_AGENDAMENTO_VIAGEM_PASSAGEIRO,
        payload: response
      })
  );
}
